// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --main-color: #1a8fff;
  --text-color: #777;
  --text-color-light: #ccc;
  --border-color: #eee;
  --bg-color: #f9f9f9;
  --neutral-color: #F9F9F9;
}

.calendar {
  display: block;
  position: relative;
  width: 100%;
  background: var(--neutral-color);
  border-radius: 16px;
  font-family: "Proxima Nova", sans-serif;
}
.calendar .row {
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}
.calendar .row-middle {
  align-items: center;
}
.calendar .col {
  flex-grow: 1;
  flex-basis: 0;
  max-width: 100%;
}
.calendar .col-start {
  justify-content: flex-start;
  text-align: left;
}
.calendar .col-center {
  justify-content: center;
  text-align: center;
}
.calendar .col-end {
  justify-content: flex-end;
  text-align: right;
}
.calendar .header {
  padding: 9px 8px;
  display: flex;
  width: 100%;
  align-items: center;
}
.calendar .days {
  text-transform: uppercase;
  font-weight: 400;
  color: var(--text-color-light);
  font-size: 70%;
  padding: 0.75em 0;
}
.calendar .body {
  overflow: hidden;
}
.calendar .body .cell {
  position: relative;
  width: 63px;
  height: 70px;
  overflow: hidden;
  cursor: pointer;
  background: var(--neutral-color);
  transition: 0.25s ease-out;
  font-size: 1.5em;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.calendar .body .cell .date-cell {
  padding: 7px 8px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: 0.2s ease-in-out;
}
.calendar .body .cell .date-cell:hover {
  background: var(--bg-color);
  transition: 0.5s ease-out;
}
.calendar .body .cell .date-cell .day {
  font-size: 8px;
  font-weight: 600;
  color: #949494;
  margin: 0;
  margin-bottom: 8px;
}
.calendar .body .cell .date-cell .number {
  font-size: 14px;
  font-weight: 400;
  color: #C9C9C9;
  margin: 0;
}
.calendar .body .cell:hover .bg,
.calendar .body .selected .bg {
  opacity: 0.05;
  transition: 0.5s ease-in;
}
.calendar .body .selected .date-cell {
  background-color: #FEF7DE;
}
.calendar .body .selected .date-cell > p {
  color: #FAC91F !important;
  font-weight: 600 !important;
}
.calendar .body .today .date-cell {
  background-color: #FAC91F;
}
.calendar .body .today .date-cell > p {
  color: white !important;
  font-weight: 600 !important;
}
.calendar .body .col {
  flex-grow: 0;
  flex-basis: 14.2857142857%;
  width: 14.2857142857%;
}
.calendar .body .disabled {
  color: var(--text-color-light);
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/components/WeeklyCalendar/weeklyCalendar.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;EACA,kBAAA;EACA,wBAAA;EACA,oBAAA;EACA,mBAAA;EACA,wBAAA;AACJ;;AAEA;EACI,cAAA;EACA,kBAAA;EACA,WAAA;EACA,gCAAA;EACA,mBAAA;EACA,uCAAA;AACJ;AACI;EACI,SAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;AACR;AAEI;EACI,mBAAA;AAAR;AAGI;EACI,YAAA;EACA,aAAA;EACA,eAAA;AADR;AAII;EACI,2BAAA;EACA,gBAAA;AAFR;AAKI;EACI,uBAAA;EACA,kBAAA;AAHR;AAMI;EACI,yBAAA;EACA,iBAAA;AAJR;AAOI;EACI,gBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;AALR;AAQI;EACI,yBAAA;EACA,gBAAA;EACA,8BAAA;EACA,cAAA;EACA,iBAAA;AANR;AASI;EACI,gBAAA;AAPR;AAQQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;EACA,0BAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AANZ;AAQY;EACI,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,4BAAA;AANhB;AAQgB;EACI,2BAAA;EACA,yBAAA;AANpB;AASgB;EACI,cAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;AAPpB;AAUgB;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AARpB;AAaQ;;EAEI,aAAA;EACA,wBAAA;AAXZ;AAeY;EACI,yBAAA;AAbhB;AAegB;EACI,yBAAA;EACA,2BAAA;AAbpB;AAmBY;EACI,yBAAA;AAjBhB;AAmBgB;EACI,uBAAA;EACA,2BAAA;AAjBpB;AAsBQ;EACI,YAAA;EACA,0BAAA;EACA,qBAAA;AApBZ;AAuBQ;EACI,8BAAA;EACA,oBAAA;AArBZ","sourcesContent":[":root {\n    --main-color: #1a8fff;\n    --text-color: #777;\n    --text-color-light: #ccc;\n    --border-color: #eee;\n    --bg-color: #f9f9f9;\n    --neutral-color: #F9F9F9;\n}\n\n.calendar {\n    display: block;\n    position: relative;\n    width: 100%;\n    background: var(--neutral-color);\n    border-radius: 16px;\n    font-family: 'Proxima Nova', sans-serif;\n\n    .row {\n        margin: 0;\n        padding: 0;\n        display: flex;\n        flex-direction: row;\n        flex-wrap: wrap;\n        width: 100%;\n    }\n\n    .row-middle {\n        align-items: center;\n    }\n\n    .col {\n        flex-grow: 1;\n        flex-basis: 0;\n        max-width: 100%;\n    }\n\n    .col-start {\n        justify-content: flex-start;\n        text-align: left;\n    }\n\n    .col-center {\n        justify-content: center;\n        text-align: center;\n    }\n\n    .col-end {\n        justify-content: flex-end;\n        text-align: right;\n    }\n\n    .header {\n        padding: 9px 8px;\n        display: flex;\n        width: 100%;\n        align-items: center;\n    }\n\n    .days {\n        text-transform: uppercase;\n        font-weight: 400;\n        color: var(--text-color-light);\n        font-size: 70%;\n        padding: 0.75em 0;\n    }\n\n    .body {\n        overflow: hidden;\n        .cell {\n            position: relative;\n            width: 63px;\n            height: 70px;\n            overflow: hidden;\n            cursor: pointer;\n            background: var(--neutral-color);\n            transition: 0.25s ease-out;\n            font-size: 1.5em;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            flex-direction: column;\n\n            .date-cell {\n                padding: 7px 8px;\n                border-radius: 8px;\n                display: flex;\n                flex-direction: column;\n                align-items: center;\n                transition: .2s ease-in-out;\n\n                &:hover {\n                    background: var(--bg-color);\n                    transition: 0.5s ease-out;\n                }\n\n                .day {\n                    font-size: 8px;\n                    font-weight: 600;\n                    color: #949494;\n                    margin: 0;\n                    margin-bottom: 8px;\n                }\n\n                .number {\n                    font-size: 14px;\n                    font-weight: 400;\n                    color: #C9C9C9;\n                    margin: 0;\n                }\n            }\n        }\n\n        .cell:hover .bg,\n        .selected .bg {\n            opacity: 0.05;\n            transition: 0.5s ease-in;\n        }\n\n        .selected {\n            .date-cell {\n                background-color: #FEF7DE;\n\n                >p {\n                    color: #FAC91F !important;\n                    font-weight: 600 !important;\n                }\n            }\n        }\n\n        .today {\n            .date-cell {\n                background-color: #FAC91F;\n\n                >p {\n                    color: white !important;\n                    font-weight: 600 !important;\n                }\n            }\n\n        }\n        .col {\n            flex-grow: 0;\n            flex-basis: calc(100% / 7);\n            width: calc(100% / 7);\n        }\n\n        .disabled {\n            color: var(--text-color-light);\n            pointer-events: none;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
